/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

import { buildEntityKey } from '../../utils';
import { AttributeActions, EAttributeActions } from '../actions';
import { IAttributeState, initialAttributeState } from '../state';

export function attributeReducer(state = initialAttributeState, action: AttributeActions): IAttributeState {
  switch (action.type) {
    case EAttributeActions.LoadAttributes: {
      return {
        ...state,
        loading: true,
        error: false
      };
    }
    case EAttributeActions.LoadAttributesSuccess: {
      return {
        ...state,
        items: action.payload,
        loading: false,
        error: false
      };
    }
    case EAttributeActions.LoadAttributesFailure: {
      return {
        ...state,
        loading: false,
        error: true
      };
    }
    case EAttributeActions.SetSelectedAttributes: {
      return {
        ...state,
        selectedAttributes: action.payload
      };
    }
    case EAttributeActions.RemoveSelectedAttributeValue: {
      const { attributeId, value } = action.payload;
      const selectedAttributes = state.selectedAttributes
        .map(attr => (attr.attributeId === attributeId ? { ...attr, stringValues: attr.stringValues.filter(v => v !== value) } : attr))
        .filter(attr => attr.stringValues.length > 0);
      return {
        ...state,
        selectedAttributes
      };
    }
    case EAttributeActions.SearchAssignments: {
      return {
        ...state,
        assignmentsLoading: true,
        assignmentsError: false
      };
    }
    case EAttributeActions.MapEntities: {
      return {
        ...state,
        assignmentsLoading: true,
        assignmentsError: false,
        lastSearchedEntityKey: buildEntityKey(action.payload.legacyEntityIds)
      };
    }
    case EAttributeActions.SearchAssignmentsSuccess: {
      return {
        ...state,
        assignments: action.payload,
        assignmentsLoading: false,
        assignmentsError: false
      };
    }
    case EAttributeActions.SearchAssignmentsFailure: {
      return {
        ...state,
        assignmentsLoading: false,
        assignmentsError: true
      };
    }
    case EAttributeActions.MapEntitiesFailure: {
      return {
        ...state,
        assignmentsLoading: false,
        assignmentsError: true
      };
    }
    case EAttributeActions.ClearAssignments: {
      return {
        ...state,
        selectedAttributes: [],
        assignments: [],
        assignmentsLoading: false,
        assignmentsError: false,
        lastSearchedEntityKey: ''
      };
    }
    case EAttributeActions.UpdateEntityMappings: {
      const legacyMapToUuid = { ...state.legacyMapToUuid };
      const uuidMapToLegacy = { ...state.uuidMapToLegacy };
      for (const item of action.payload) {
        const legacyKey = `${item.entityType}:${item.legacyId}`;
        legacyMapToUuid[legacyKey] = item.uuid;
        uuidMapToLegacy[item.uuid] = legacyKey;
      }
      return {
        ...state,
        legacyMapToUuid,
        uuidMapToLegacy
      };
    }
    default:
      return state;
  }
}
